<template>
  <v-dialog v-model="dialog" width="800" :retain-focus="false">
    <v-card>
      <v-card-title class="headline">
        <span>{{ service.type ? service.type.name : '' }} </span>
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <p class="mt-2">Aktywna</p>
              <v-switch
                  v-model="service.isActive"
                  class="mt-0 pt-0"
                  :label="service.isActive ? 'Tak' : 'Nie'"
                  :persistent-hint="true"
              ></v-switch>
              <p class="mt-2">Promowana</p>
              <v-switch
                  v-model="service.promoted"
                  class="mt-0 pt-0"
                  :label="service.promoted ? 'Tak' : 'Nie'"
                  :persistent-hint="true"
              ></v-switch>
              <p class="mt-2">Natychmiastowa rezerwacja</p>
              <v-switch
                  v-model="service.instant"
                  class="mt-0 pt-0"
                  :label="service.instant ? 'Tak' : 'Nie'"
                  :persistent-hint="true"
              ></v-switch>
              <v-img v-bind:src="service.image.url" v-if="service.image"></v-img>
              <v-btn v-if="service.image" v-on:click="removeImage">usuń zdjęcie</v-btn>
              <v-select
                  v-model="service.vatRate"
                  :items="vatRates"
                  label="Stawka VAT"
              ></v-select>
              <v-text-field
                  v-if="service.availableWithTransport && !isCarRental"
                  v-model="service.priceWithTransport"
                  class="pt-0"
                  type="number"
                  label="Cena netto"
                  placeholder=" "
              ></v-text-field>
              <div v-if="isCarRental">
                <v-text-field v-model="service.name" :rules="formRules.name" label="Nazwa samochodu"></v-text-field>
                <p class="mt-2">Ceny
                  <v-icon size="24" right @click="addPrice">
                    mdi-plus
                  </v-icon>
                </p>
                <div v-for="(carRentalPrice, key) in carRentalPrices" :key="carRentalPrice">
                  <p class="font-weight-bold">Cena {{ key + 1 }}
                    <v-icon size="24" right @click="removePrice(key)">
                      mdi-minus
                    </v-icon>
                  </p>
                  <v-row>
                    <v-col>
                      <v-select v-model="carRentalPrice.dayFrom" label="Od dnia" :rules="formRules.required"
                                :items="getDays()"
                                item-text="value"
                                item-value="key"></v-select>
                    </v-col>
                    <v-col>
                      <v-select v-model="carRentalPrice.monthFrom" label="Od miesiąca" :rules="formRules.required"
                                :items="getMonths()"
                                item-text="value"
                                item-value="key"></v-select>
                    </v-col>
                    <v-col>
                      <v-select v-model="carRentalPrice.dayTo" label="Do dnia" :rules="formRules.required"
                                :items="getDays()"
                                item-text="value"
                                item-value="key"></v-select>
                    </v-col>
                    <v-col>
                      <v-select v-model="carRentalPrice.monthTo" label="Do miesiąca" :rules="formRules.required"
                                :items="getMonths()"
                                item-text="value"
                                item-value="key">>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                          v-model="carRentalPrice.prices"
                          class="pt-0"
                          label="Ceny"
                          placeholder="liczba dni,cena"
                          :rules="formRules.required"></v-textarea>
                    </v-col>
                    <v-col>
                      <v-textarea
                          v-model="carRentalPrice.weekendPrices"
                          class="pt-0"
                          label="Ceny weekendowe"
                          placeholder="liczba dni,cena"></v-textarea>
                    </v-col>
                  </v-row>
                </div>
                <v-text-field v-model="service.carRental.deposit" label="Kaucja bez ubezpieczenia"></v-text-field>
                <v-text-field v-model="service.carRental.depositWithInsurance" label="Kaucja z ubezpieczeniem"></v-text-field>
                <v-text-field v-model="service.carRental.ownContribution" label="Wkład własny bez ubezpieczenia"></v-text-field>
                <v-text-field v-model="service.carRental.ownContributionWithInsurance" label="Wkład własny z ubezpieczeniem"></v-text-field>
                <v-text-field v-model="service.carRental.insuranceValue" label="Ubezpieczenie (za dzień)"></v-text-field>

                <v-select
                    :items="getLocationTypes()"
                    v-model="service.carRental.location"
                    label="Lokalizacja odbioru"
                    item-value="key"
                    item-text="value"
                    solo
                    class="wastemaster-input-elevation"
                ></v-select>
                <v-textarea v-model="service.carRental.additionalLocation"
                            label="Dokładna lokalizacja odiboru"></v-textarea>
                <v-textarea v-model="service.carRental.fuelPolicy" label="Polityka paliwowa"></v-textarea>
                <v-text-field v-model="service.carRental.kilometerLimit" label="Limit kilometrów"></v-text-field>
                <v-textarea v-model="service.carRental.additionalInformation" label="Dodatkowe informacje"></v-textarea>
                <v-select
                    :items="getTransmissionTypes()"
                    :rules="formRules.transmissionType"
                    v-model="service.carRental.transmission"
                    label="Skrzynia biegów"
                    item-value="key"
                    item-text="value"
                    solo
                    class="wastemaster-input-elevation"
                ></v-select>
                <v-select
                    :items="getNumberOfSeats()"
                    :rules="formRules.numberOfSeats"
                    v-model="service.carRental.numberOfSeats"
                    label="Liczba miejsc"
                    item-value="key"
                    item-text="value"
                    solo
                    class="wastemaster-input-elevation"
                ></v-select>
                <v-select
                    :items="getNumberOfDoors()"
                    :rules="formRules.numberOfDoors"
                    v-model="service.carRental.numberOfDoors"
                    label="Liczba drzwi"
                    item-value="key"
                    item-text="value"
                    solo
                    class="wastemaster-input-elevation"
                ></v-select>
                <v-select
                    :items="getFuelTypes()"
                    :rules="formRules.fuelType"
                    v-model="service.carRental.fuel"
                    label="Paliwo"
                    item-value="key"
                    item-text="value"
                    solo
                    class="wastemaster-input-elevation"
                ></v-select>
                <v-checkbox
                    v-model="service.carRental.airConditioning"
                    class="pt-0"
                    label="Klimatyzacja"
                ></v-checkbox>
                <v-select
                    :items="additionalBenefits"
                    v-model="service.additionalBenefit"
                    label="Dodatkowe informacje"
                    item-value="value"
                    item-text="text"
                    solo
                    class="wastemaster-input-elevation"
                ></v-select>
              </div>
              <p class="mt-2" v-if="service.availableWithTransport">Opis</p>
              <ckeditor
                  v-if="service.availableWithTransport"
                  v-model="service.availableWithTransportDescription"
                  :editor="editor"
                  :config="editorConfig"
                  class="pt-0"
                  hint="Opis"
                  placeholder="Opis"
              ></ckeditor>
              <p class="mt-2" v-if="service.availableWithTransport">Szczegóły usługi po zamówieniu</p>
              <ckeditor
                  v-if="service.availableWithTransport"
                  v-model="service.availableWithTransportSummary"
                  :editor="editor"
                  :config="editorConfig"
                  class="mt-4"
                  label="test"
                  hint="Szczegóły usługi po zamówieniu"
                  placeholder="Szczegóły usługi po zamówieniu"
              ></ckeditor>
              <vue-dropzone id="dropzone" :options="dropzoneOptions" class="mt-4"
                            v-on:vdropzone-success="storeImageId"
                            v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                  v-model="service.updateConnected"
                  class="pt-0"
                  label="Aktualizuj ceny i opis w powiązanych usługach"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                  v-model="service.updateAdditionalBenefitConnected"
                  class="pt-0"
                  label="Aktualizuj dodatkowe informacje w powiązanych usługach"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
            >Zapisz&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "../services/Auth";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import unitMixin from "@/mixins/unitMixin";
import locationTypeMixin from "@/mixins/locationTypeMixin";
import transmissionTypeMixin from "@/mixins/transmissionTypeMixin";
import fuelTypeMixin from "@/mixins/fuelTypeMixin";

export default {
  name: 'ModalEditService',
  components: {
    vueDropzone: vue2Dropzone,
    ckeditor: CKEditor.component,
  },
  props: {
    item: {},
  },
  mixins: [
    locationTypeMixin,
    transmissionTypeMixin,
    fuelTypeMixin,
    transactionTypeMixin,
    transportConditionMixin,
    categoryMixin,
    priceMixin,
    paymentConditionMixin,
    dateMixin,
    validationHelpers,
    unitMixin
  ],
  created() {
    this.loadPartners();
  },
  data() {
    return {
      partners: null,
      unit: "",
      dialog: false,
      form: {
        photosIds: [],
      },
      serviceBuyTypes: [
        {value: 'paidUtilization', text: 'Płatna utylizacja'},
        {value: 'wastePurchase', text: 'Kupno odpadu'},
      ],
      whoTransport: [
        {value: null, text: 'Wybierz'},
        {value: 'client', text: 'Klient'},
        {value: 'seller', text: 'Sprzedawca'},
        {value: 'wm', text: 'Wastemaster'},
      ],
      wmRoles: [
        {value: 'mediation', text: 'Pośrednictwo'},
        {value: 'sell', text: 'Sprzedaż'},
      ],
      feePayer: [
        {value: 'client', text: 'Klient'},
        {value: 'partner', text: 'Partner'},
      ],
      additionalBenefits: [
        {value: 'FREE_CANCELLATION', text: 'Bezpłatne odwołanie rezerwacji'},
        {value: 'FREE_DRIVER', text: 'Dodatkowy kierowca gratis'},
        {value: 'FREE_WINTER_TIRES', text: 'Opony zimowe wliczone w cenę'},
        {value: 'NO_ADDITIONAL_FEES', text: 'Brak dodatkowych opłat'},
        {value: 'NO_DEPOSIT', text: 'Brak depozytu'},
        {value: 'CASH_DEPOSIT', text: 'Akceptujemy kaucję w gotówce'},
        {value: 'IMMEDIATE_CONFIRMATION', text: 'Natychmiastowe potwierdzenie rezerwacji'},
      ],
      formRules: {
        unit: [(value) => !!value || 'wybierz jednostkę'],
        buyType: [(value) => !!value || 'wybierz typ'],
        transmissionType: [(value) => (this.isCarRental && !!value) || 'wybierz skrzynię biegów'],
        numberOfSeats: [(value) => (this.isCarRental && !!value) || 'wybierz liczbę miejsc'],
        numberOfDoors: [(value) => (this.isCarRental && !!value) || 'wybierz liczbę drzwi'],
        fuelType: [(value) => (this.isCarRental && !!value) || 'wybierz paliwo'],
        name: [(value) => (this.isCarRental && !!value) || 'wpisz nazwe'],
        required: [(value) => (this.isCarRental && !!value) || 'wpisz wartość'],
      },
      valid: false,
      serviceTypes: [],
      service: {
        partner: null,
        type: null,
        wmRole: null,
        wmPrice: null,
        whoPayForWm: null,
        whoTransport: null,
        buyType: null,
        availableWithTransport: true,
        availableWithTransportDescription: '',
        availableWithTransportSummary: '',
        priceWithTransport: null,
        availableWithoutTransport: false,
        availableWithoutTransportDescription: '',
        availableWithoutTransportSummary: '',
        priceWithoutTransport: null,
        photosIds: [],
        removePhoto: false,
        unit: '',
        isSale: true,
        vatRate: null,
        minimumQuantity: null,
        maximumQuantity: null,
        isActive: false,
        promoted: false,
        instant: false,
        carRental: null,
        name: null,
        additionalBenefit: null,
        updateConnected: false,
        updateAdditionalBenefitConnected: false,
      },
      vatRates: [0, 5, 8, 23],
      carRentalPrices: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}/api/price-list/company-branch/${this.item}/service/images`,
        thumbnailWidth: 150,
        maxFilesize: 1024 * 20,
        maxFiles: 1,
        acceptedFiles: 'image/*',
        addRemoveLinks: true,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
        }
      },
      editor: ClassicEditor,
      editorConfig: {
        id: this.item,
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ],
        }
      },
    }
  },
  computed: {
    isCarRental() {
      return this.service.carRental;
    },
  },
  methods: {
    getMonths() {
      let months = [];
      for (let i = 1; i <= 12; i++) {
        months.push({value: i, key: i});
      }

      return months;
    },
    getDays() {
      let days = [];
      for (let i = 1; i <= 31; i++) {
        days.push({value: i, key: i});
      }

      return days;
    },
    getNumberOfSeats() {
      let numberOfSeats = [];

      for (let i = 1; i <= 9; i++) {
        numberOfSeats.push({value: i, key: i});
      }

      return numberOfSeats;
    },
    getNumberOfDoors() {
      let numberOfDoors = [];

      for (let i = 3; i <= 5; i++) {
        numberOfDoors.push({value: i, key: i});
      }

      return numberOfDoors;
    },
    open(service) {
      this.service = service;
      if (this.service.carRental) {
        this.carRentalPrices = [];
        this.service.carRental.prices.forEach((price) => {
          let carRentalPrice = {
            monthFrom: price.monthFrom,
            monthTo: price.monthTo,
            dayFrom: price.dayFrom,
            dayTo: price.dayTo,
            prices: '',
            weekendPrices: ''
          }

          for (const [days, price] of Object.entries(price.prices)) {
            carRentalPrice.prices += `${days},${price}\n`;
          }

          for (const [days, price] of Object.entries(price.weekendPrices)) {
            carRentalPrice.weekendPrices += `${days},${price}\n`;
          }

          this.carRentalPrices.push(carRentalPrice);
        });
      }

      this.dialog = true
      this.getServiceTypes();
    },
    addPrice() {
      this.carRentalPrices.push({
        monthFrom: null,
        monthTo: null,
        dayFrom: null,
        dayTo: null,
        prices: '',
        weekendPrices: ''
      });
    },
    removePrice(index) {
      this.carRentalPrices.splice(index, 1);
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        this.$root.$emit('notifyWarning', {
          html: 'Uzupełnij wymagane pola.',
        });
        return
      }

      let servicePrices = [];

      this.carRentalPrices.forEach((price) => {
        let prices = {};
        let weekendPrices = {};

        price.prices.split('\n').forEach((line) => {
          let [days, price] = line.split(',');
          if (days && price) {
            prices[days] = price;
          }
        });
        price.weekendPrices.split('\n').forEach((line) => {
          let [days, price] = line.split(',');
          if (days && price) {
            weekendPrices[days] = price;
          }
        });

        if (weekendPrices === {}) {
          weekendPrices = null;
        }

        price.prices = prices;
        price.weekendPrices = weekendPrices;

        servicePrices.push(price);
      });

      const service = {
        partner: this.service.partner ? this.service.partner.id : null,
        availableWithTransport: this.service.availableWithTransport ?? false,
        availableWithTransportDescription: this.service.availableWithTransportDescription ?? '',
        availableWithTransportSummary: this.service.availableWithTransportSummary ?? '',
        priceWithTransport: this.service.priceWithTransport ? parseFloat(this.service.priceWithTransport) : null,
        availableWithoutTransport: this.service.availableWithoutTransport ?? false,
        availableWithoutTransportDescription: this.service.availableWithoutTransportDescription ?? '',
        availableWithoutTransportSummary: this.service.availableWithoutTransportSummary ?? '',
        priceWithoutTransport: this.service.priceWithoutTransport ? parseFloat(this.service.priceWithoutTransport) : null,
        unit: 'PIECE',
        photosIds: this.form.photosIds,
        removePhoto: this.service.removePhoto,
        isSale: this.service.isSale,
        isActive: this.service.isActive,
        promoted: this.service.promoted,
        instant: this.service.instant,
        vatRate: this.service.vatRate,
        buyType: this.service.buyType,
        wmRole: this.service.wmRole,
        wmPrice: this.service.wmPrice,
        whoPayForWm: this.service.whoPayForWm,
        whoTransport: this.service.whoTransport,
        minimumQuantity: this.service.minimumQuantity !== '' ? this.service.minimumQuantity : null,
        maximumQuantity: this.service.maximumQuantity !== '' ? this.service.maximumQuantity : null,
        prices: servicePrices,
        name: this.service.name,
        additionalBenefit: this.service.additionalBenefit,
        updateConnected: this.service.updateConnected,
        updateAdditionalBenefitConnected: this.service.updateAdditionalBenefitConnected,
      }

      if (this.service.carRental) {
        service.location = this.service.carRental.location;
        service.additionalLocation = this.service.carRental.additionalLocation;
        service.fuelPolicy = this.service.carRental.fuelPolicy;
        service.kilometerLimit = this.service.carRental.kilometerLimit;
        service.additionalInformation = this.service.carRental.additionalInformation;
        service.transmission = this.service.carRental.transmission;
        service.numberOfSeats = this.service.carRental.numberOfSeats;
        service.numberOfDoors = this.service.carRental.numberOfDoors;
        service.fuel = this.service.carRental.fuel;
        service.airConditioning = this.service.carRental.airConditioning;
        service.deposit = this.service.carRental.deposit;
        service.depositWithInsurance = this.service.carRental.depositWithInsurance;
        service.ownContribution = this.service.carRental.ownContribution;
        service.ownContributionWithInsurance = this.service.carRental.ownContributionWithInsurance;
        service.insuranceValue = this.service.carRental.insuranceValue;
      }
      
      api
          .put('/api/price-list/company-branch/' + this.item + '/service/' + this.service.id, service)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Usługa została zaktualizowana.',
            });
            this.dialog = false;
            this.service.type = '';
            this.$parent.load();
          })
          .catch((error) => {
            console.error('Error when editing a service:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    getServiceTypes() {
      api
          .get('/api/price-list/company-branch/' + this.item + '/service/type')
          .then((response) => {
            response.data.forEach(service => {
              service.name = service.name + ' - ' + service.category;
              this.serviceTypes.push(service);
            });
          })
          .catch((error) => {
            console.error('Error when getting a service types:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    storeImageId(event, image) {
      this.form.photosIds.push(image.id);
    },
    removeImage() {
      this.service.image = null;
      this.service.removePhoto = true;
      this.form.photosIds = [];
    },
    async loadPartners() {
      api
          .get('/api/companies?partner=true')
          .then((data) => {
            this.partners = data.data.items;
          })
          .catch((error) => {
            console.error('Error when loading partners: ', error);
          })
    },
  },
}
</script>

<style scoped></style>
